import z from "zod";
import { DataTypes } from "../types/data.types";

export const outputPreviewDataTypeSchema = z.nativeEnum(DataTypes);

export const outputPreviewColumnSchema = z.object({
  sourceFileFieldId: z.number(),
  fieldName: z.string(),
  selected: z.boolean(),
  fieldDataType: outputPreviewDataTypeSchema,
  fieldLength: z.number().int().min(0).max(1024),
  isPrimaryKey: z.boolean(),
});

export const outputPreviewFormSchema = z
  .object({
    createPhysicalTable: z.enum(["yes", "no"]),
    columns: z.array(outputPreviewColumnSchema),
  })
  .superRefine((data, ctx) => {
    data.columns.forEach((col, i) => {
      if (!col.selected) return;
      if (col.fieldDataType === "string") {
        if (col.fieldLength < 1 || col.fieldLength > 1024) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "String length must be between 1 and 1024",
            path: ["columns", i, "fieldLength"],
          });
        }
      } else if (col.fieldLength !== 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Length must be 0 for non-string types",
          path: ["columns", i, "fieldLength"],
        });
      }
    });
  });

export type OutputPreviewFormValues = z.infer<typeof outputPreviewFormSchema>;
